export default __webpack_public_path__ + "static/media/player-red-cards.f190e62e.svg";